module.exports = __webpack_public_path__ + "static/media/black.1e159dd2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/silver-aluminum-case/black.jpeg
// module id = 2045
// module chunks = 0